var exports = {
  "O": "Typing.module__dot___RG1Oal",
};

module.exports = exports;
